import React from 'react';
import '../assets/styles/card-component.css';
import {formatDate} from '../utilities/formatDate';
import NavigationButton from './NavigationButton';
import { routePath } from '../routes/routePath';
const DepositCard = ({ deposit, index }) => {
  let state = deposit.state === 'pending'
    ? 'تحت المراجعة'
    : deposit.state === 'rejected'
      ? 'مرفوضة'
      : deposit.state === 'accepted'
        ? 'مقبولة'
        : 'غير معروف';
 
  return (
    <div className="card mb-4 d-flex flex row justify-content-between" style={styles.cardContainer}>
      <div
        className={`card-layer `}
        style={styles.cardLayer}
      >
        <span className='badge bg-secondary'> {index+1}</span>
        {/* Display deposit Details */}
        <p style={styles.standardText}>
         
          {deposit.mainStandardSequence} {deposit.mainStandardName}
        </p>
        <hr style={styles.separator} />
        
        <p style={styles.standardText}>
          {deposit.mainStandardSequence} / {deposit.subStandardSequence} {deposit.subStandardName}
        </p>
        <hr style={styles.separator} />

        <p style={styles.standardText}>
          {deposit.mainStandardSequence} / {deposit.subStandardSequence} - {deposit.itemSequence} {deposit.itemName}
        </p>
        <hr style={styles.separator} />

        <p style={styles.detailText}>الرقم المرجعي: {deposit.referenceNumber}</p>
        <hr style={styles.separator} />

        <p style={styles.detailText}>النقاط: {deposit.itemScore}</p>
        <hr style={styles.separator} />

       <p style={styles.detailText}>
          تاريخ الايداع: {formatDate(deposit.createdAt)}
        </p>
        <hr style={styles.separator} />
   
     
             <p className={`detailText border-radius-3 white-color p-1 ${deposit.state === 'accepted' ? 'success-bg' : deposit.state === 'rejected' ? 'danger-bg' :  'mid-gray-bg' }`}>
          الحالة: {state}
        </p>

        {deposit.rejectReason && (
        <div style={styles.detailText}>
          <p className='danger-bg p-2 white-color border-radius-3'>
            سبب الرفض: {deposit.rejectReason}
          </p>
        </div>
        )}
    {deposit.auditorNote && 
        <p className='alert alert-warning' style={styles.detailText}>
       ملاحظة : {deposit.auditorNote}
        </p>
        }
    {deposit.reviewerNote && 
        <p className='alert alert-warning' style={styles.detailText}>
       ملاحظة : {deposit.reviewerNote}
        </p>
        }
      </div>
      <NavigationButton
      path={routePath.displayDeposit(deposit.depositId)}
      label="عرض الايداع"
      className="btn  primary-bg text-light"
      newTab
      />
    </div>
  );
};

// Define some styles for cleaner layout
const styles = {
  cardContainer: {
    borderRadius: '8px',
    overflow: 'hidden',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    width: '100%', // Full width in its container
    maxWidth: '300px', // Set a maximum width for larger screens
    margin: '10px', // Center align the card
    boxSizing: 'border-box',
  },
  cardLayer: {
    padding: '16px',
    backgroundColor: '#fff',
   },
  standardText: {
    fontWeight: 'bold',
    fontSize: '1.1rem',
    margin: '8px 0',
  },
  detailText: {
    fontSize: '1rem',
    margin: '8px 0',
    color: '#333',
  },
  separator: {
    margin: '12px 0',
    border: '1px solid #54667E',
  },
  rejectReasonText: {
    backgroundColor: '#f44336',
    color: '#fff',
    padding: '8px',
    borderRadius: '4px',
    marginTop: '12px',
  },
};

export default DepositCard;
